import { APPROVED_LENDERS } from 'variables/constants';

/**
 * Check if a lender name is in the approved lenders list (case-insensitive)
 * @param name - The lender name to check
 * @returns true if the lender is approved, false otherwise
 */
export const isApprovedLender = (name: string): boolean => {
  if (!name) return true;
  const lowerCaseName = name.toLowerCase();
  return Object.keys(APPROVED_LENDERS).some(
    (key) => key.toLowerCase() === lowerCaseName,
  );
};

/**
 * Check if a lender requires remarks (is non-standard)
 * For Max Insurance, all lenders are allowed
 * @param name - The lender name to check
 * @param insuranceCompany - The insurance company name
 * @returns true if the lender requires remarks (is non-standard), false otherwise
 */
export const isNonStandardLender = (
  name: string,
  insuranceCompany?: string,
): boolean => {
  if (!name) return false;

  // For Max Insurance, all lenders are allowed
  if (insuranceCompany?.toLowerCase().includes('max')) {
    return false;
  }

  return !isApprovedLender(name);
};
